import { ReportTemplateTypeEnum } from "../../../../services/api/types/reports/reports";

// Helper function to convert camelCase or snake_case to readable format
export const formatKey = (key: string): string => {
  let formatted = key.replace(/_/g, " ");

  // Add spaces before capital letters (but not the first one)
  formatted = formatted.replace(/([a-z])([A-Z])/g, "$1 $2");

  // Capitalize first letter
  return (
    formatted.charAt(0).toUpperCase() + formatted.slice(1).toLocaleLowerCase()
  );
};

// Build a filter summary row, dropping fields with no value
export const formatFilterRow = (fields: [string, unknown][]): string[] =>
  fields
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([label, value]) => `${label}: ${value}`);

// Format date and time
export const formatDate = (date: Date) => {
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatTime = (date: Date) => {
  return date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const generateFileName = (reportType: ReportTemplateTypeEnum) => {
  const portalName = sessionStorage.getItem("selectedPortalName");

  // Get current date when export is triggered and format as "DD MMM, YYYY"
  const currentDate = new Date();
  const downloadDate = currentDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return `${portalName} ${downloadDate} ${reportType}`;
};

export const generateCertificatesFileName = (): string => {
  const portalName = sessionStorage.getItem("selectedPortalName");
  const currentDate = new Date();
  const downloadDate = currentDate.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  return `${portalName} ${downloadDate} Certificates`;
};
